"use strict";

($ => {
    /**
     * Usage Spy
     * Used to monitor the updated to the CARC and report the usage data to the backend in order to process
     * which usages will be logged as billable or not.
     */
    class UsageSpy {
        timeout = null;
        requestDelay = 2000;
        endpoint = '/api/usages';
        token = $('meta[name="csrf_token"]').attr('content');
        isDirty = false;
        zip = null;
        dob = null;
        gender = null;
        height = null;
        covidAge = null;
        hospitalRisk = null;
        icuRisk = null;
        deathRisk = null;
        birth_month = null;
        birth_day = null;
        birth_year = null;
        fmd = null;
        smoking = null;
        vitamin_d = null;
        systolic_blood_pressure = null;
        diastolic_blood_pressure = null;
        blood_pressure_treated = null;
        bmi = null;
        waist = null;
        a1c = null;
        lipids_tg = null;
        lipids_hdlc = null;
        lipids_ldlc = null;
        underlying_kidney = null;
        underlying_chronic_lung = null;
        underlying_cardio = null;
        underlying_immuno = null;
        vac_year = null;
        vac_month = null;
        vac_day = null;
        imperial = null;

        init() {
            $('input, select').on('change', e => {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.handleInputChange();
                }, this.requestDelay);
            });
        }

        set(field, value) {
            if (this[field] !== value) {
                this.isDirty = true;
                this[field] = value;
            }
        }

        formatDob(data) {
            const month = parseInt(data.birth_month, 10), day = parseInt(data.birth_day, 10),
                year = parseInt(data.birth_year, 10);
            if (month > 0 && day > 0 && year > 0) {
                return `${month}/${day}/${year}`;
            } else {
                return null;
            }
        }

        parseGender(gender) {
            if (gender === undefined || gender === null) {
                return null;
            } else if (gender === 0) {
                return 'male';
            } else {
                return 'female';
            }
        }

        updateValues(data) {
            this.set('zip', data.zip);
            this.set('dob', this.formatDob(data));
            this.set('gender', this.parseGender(data.gender));
            this.set('height', data.height);
            this.set('covidAge', `${data.vac_year}y ${data.vac_month}m ${data.vac_day}d`);
            this.set('hospitalRisk', parseFloat(data.hospital));
            this.set('icuRisk', parseFloat(data.icu));
            this.set('deathRisk', parseFloat(data.death));
            this.set('birth_month', data.birth_month);
            this.set('birth_day', data.birth_day);
            this.set('birth_year', data.birth_year);
            this.set('fmd', data.fmd);
            this.set('smoking', data.smoking);
            this.set('vitamin_d', data.vitamin_d);
            this.set('systolic_blood_pressure', data.systolic_blood_pressure);
            this.set('diastolic_blood_pressure', data.diastolic_blood_pressure);
            this.set('blood_pressure_treated', data.blood_pressure_treated);
            this.set('bmi', data.bmi);
            this.set('waist', data.waist);
            this.set('a1c', data.a1c);
            this.set('lipids_tg', data.lipids_tg);
            this.set('lipids_hdlc', data.lipids_hdlc);
            this.set('lipids_ldlc', data.lipids_ldlc);
            this.set('underlying_kidney', data.underlying_kidney);
            this.set('underlying_chronic_lung', data.underlying_chronic_lung);
            this.set('underlying_cardio', data.underlying_cardio);
            this.set('underlying_immuno', data.underlying_immuno);
            this.set('vac_year', data.vac_year);
            this.set('vac_month', data.vac_month);
            this.set('vac_day', data.vac_day);
            this.set('imperial', data.imperial ? 1 : 0);
        }

        handleInputChange() {
            this.updateValues(controller.current_values);
            this.save();
        }

        prepareData() {
            return {
                zip: this.zip,
                dob: this.dob,
                gender: this.gender,
                height: this.height,
                covid_age: this.covidAge,
                hospital_risk: this.hospitalRisk,
                icu_risk: this.icuRisk,
                death_risk: this.deathRisk,
                birth_month: this.birth_month,
                birth_day: this.birth_day,
                birth_year: this.birth_year,
                fmd: this.fmd,
                smoking: this.smoking,
                vitamin_d: this.vitamin_d,
                systolic_blood_pressure: this.systolic_blood_pressure,
                diastolic_blood_pressure: this.diastolic_blood_pressure,
                blood_pressure_treated: this.blood_pressure_treated,
                bmi: this.bmi,
                waist: this.waist,
                a1c: this.a1c,
                lipids_tg: this.lipids_tg,
                lipids_hdlc: this.lipids_hdlc,
                lipids_ldlc: this.lipids_ldlc,
                underlying_kidney: this.underlying_kidney,
                underlying_chronic_lung: this.underlying_chronic_lung,
                underlying_cardio: this.underlying_cardio,
                underlying_immuno: this.underlying_immuno,
                vac_year: this.vac_year,
                vac_month: this.vac_month,
                vac_day: this.vac_day,
                imperial: this.imperial,
                _token: this.token
            };
        }

        save() {
            if (this.isDirty && !!this.zip && !!this.dob && !!this.gender) {
                $.ajax({
                    url: this.endpoint,
                    method: 'POST',
                    data: this.prepareData(),
                    success: this.success,
                    error: this.error
                });
            }
        }

        success(r) {
            this.isDirty = false;
        }

        error(r) {
            // console.error(r.responseJSON);
        }
    }

    const spy = new UsageSpy();
    spy.init();
})(jQuery);
